"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function log(message, type) {
  if (type === void 0) {
    type = 'info';
  }

  var colors = {
    info: '\x1b[34m%s\x1b[0m',
    warn: '\x1b[33m%s\x1b[0m',
    error: '\x1b[41m%s\x1b[0m'
  };
  console.log(colors[type], type, ' [gatsby-plugin-translate] ', message);
}

function clearSlugSlashes(slug) {
  var cleanSlug;

  if (slug && slug[0] === '/') {
    cleanSlug = slug.slice(1);
  }

  if (cleanSlug && cleanSlug[cleanSlug.length - 1] === '/') {
    cleanSlug = cleanSlug.slice(0, -1);
  }

  return cleanSlug;
}

var then = function then(f) {
  return function (p) {
    return p.then(f);
  };
};

var apply = function apply(f) {
  return function (firstArg) {
    return f(firstArg);
  };
};

var exec = function exec(f) {
  return f();
};

var all = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(promiseArray) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all(promiseArray);

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function all(_x) {
    return _ref.apply(this, arguments);
  };
}();

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (value) {
    return fns.reduce(function (previousValue, fn) {
      return fn(previousValue);
    }, value);
  };
};

module.exports = {
  log: log,
  clearSlugSlashes: clearSlugSlashes,
  then: then,
  all: all,
  apply: apply,
  pipe: pipe,
  exec: exec
};